module.exports = __webpack_public_path__ + "public/img/Sale02.47d6f161.png";